import { AdminAppState } from '../../state';
import { getSiteViewportState } from './get-site-viewport-state';

export const getSiteViewportHeight = (state: AdminAppState): number | string =>
  getSiteViewportState(state).height;
